﻿import { Decorators, LookupEditorBase, LookupEditorOptions } from "@serenity-is/corelib";

@Decorators.registerEditor("Matrix.Data.ViewLookupEditor")
export class ViewLookupEditor extends LookupEditorBase<ViewLookupEditorOptions, any> {

    constructor(input: JQuery, opt: ViewLookupEditorOptions) {
        super(input, opt);
    }

    protected getLookupKey() {
        return "ViewLookup." + this.options.viewName;
    }
}

export interface ViewLookupEditorOptions extends LookupEditorOptions {
    viewName: string;

}
